import React from 'react';
import ManagedPropertyCard from '../ManagedPropertyCard/ManagedPropertyCard';
import { ManagedProperty } from '../../property/property-card/PropertyCardTypes';

interface ManagedPropertyListProps {
  properties: ManagedProperty[];
  unarchivingPropertyId: number | null;
  openAddTenantModal: (property: ManagedProperty) => void;
  openEditModal: (property: ManagedProperty) => void;
  openArchiveModal: (property: ManagedProperty) => void;
  submitUnarchiveProperty: (property: ManagedProperty) => void;
}

const ManagedPropertyList: React.FC<ManagedPropertyListProps> = ({
  properties,
  unarchivingPropertyId,
  openAddTenantModal,
  openEditModal,
  openArchiveModal,
  submitUnarchiveProperty
}) => {
  return (
    <div className="space-y-4">
      {properties.map((property) => (
        <ManagedPropertyCard
          key={property.id}
          property={property}
          unarchivingPropertyId={unarchivingPropertyId}
          openAddTenantModal={openAddTenantModal}
          openEditModal={openEditModal}
          openArchiveModal={openArchiveModal}
          submitUnarchiveProperty={submitUnarchiveProperty}
        />
      ))}
    </div>
  );
};

export default ManagedPropertyList;
